import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationService } from '../services/notification.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PaginatedNotification, Notification } from '../models/notification';

@Component({
  selector: 'app-view-notification',
  templateUrl: './view-notification.component.html',
  styleUrls: ['./view-notification.component.css']
})
export class ViewNotificationComponent implements OnInit {

  notifications: Notification[];
  loading: boolean;

  page: number;
  total: number;
  max: number;

  selectedOption: string;
  errorMessage:string;

  constructor(
    private notificationService: NotificationService,
    public dialog: MatDialog,
  ) {
    this.loading = true;
    this.page = 1;
    this.total = 0;
    this.max = 10;
  }

  ngOnInit() {
    this.searchNotifications();
  }

  searchNotifications (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    this.page = page;
    if (page == null) {
      page = 1;
    }

    const status = [];
    status.push ('0'); // no leído
    status.push ('1'); // leído

    this.notificationService.getNotifications(status, page, this.max)
    .subscribe(
    data => {
      this.notifications = data.notifications;
      this.total = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status === 404) {
        this.notifications = undefined;
        this.loading = false;
      } else {
        console.log(error);
        this.notifications = undefined;
        this.loading = false;
      }
    });
  }

  read(notification) {
    notification.status = 1;
    this.notificationService.readNotification(notification)
    .subscribe(
    data => {
      this.searchNotifications();
    },
    error => {
      this.searchNotifications();
    });
  }

  onPageChange(page) {
    this.searchNotifications (page);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/view-notification/view-notification.component.ts